// Adapted from https://git.hubteam.com/HubSpot/products-ui-components/blob/master/static/js/components/display/FormattedPrice.js
import { useEffect, useMemo } from 'react';
import { FormattedIntlCurrency } from 'I18n/components/FormattedIntlCurrency';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { RECURRING_BILLING_FREQUENCIES } from '../../constants/RecurringBillingFrequencies';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
const FormattedPrice = ({
  currencyCode,
  price,
  frequency,
  testId,
  simplify = true,
  plusTax = false,
  includesFees = false,
  currencyAndAmountStyle = {}
}) => {
  const currencyAndAmount = /*#__PURE__*/_jsx(Text, Object.assign({
    "data-test-id": testId,
    as: "span"
  }, currencyAndAmountStyle, {
    children: /*#__PURE__*/_jsx(FormattedIntlCurrency, {
      value: price,
      currencyCode: currencyCode
    })
  }));
  useEffect(() => {
    if (frequency && !(frequency in RECURRING_BILLING_FREQUENCIES)) {
      throw new Error(`Invalid Billing Frequency: ${frequency}`);
    }
  }, [frequency]);
  const message = useMemo(() => {
    if (simplify && includesFees && plusTax) {
      return `payments.recurringBillingTermsShort_plusTax_includesFees.${frequency}`;
    }
    if (simplify && includesFees) {
      return `payments.recurringBillingTermsShort_includesFees.${frequency}`;
    }
    if (simplify && plusTax) {
      return `payments.recurringBillingTermsShort_plusTax.${frequency}`;
    }
    if (!simplify && includesFees && plusTax) {
      return `payments.recurringBillingTerms_plusTax_includesFees.${frequency}`;
    }
    if (!simplify && includesFees) {
      return `payments.recurringBillingTerms_includesFees.${frequency}`;
    }
    if (!simplify && plusTax) {
      return `payments.recurringBillingTerms_plusTax.${frequency}`;
    }
    if (simplify) {
      return `payments.recurringBillingTermsShort.${frequency}`;
    }
    return `payments.recurringBillingTerms.${frequency}`;
  }, [frequency, simplify, plusTax, includesFees]);
  if (!frequency) {
    return currencyAndAmount;
  }
  return /*#__PURE__*/_jsx(FormattedReactMessage, {
    message: message,
    options: {
      price: currencyAndAmount
    }
  });
};
export default FormattedPrice;